module.exports = __webpack_public_path__ + "static/img/banner.c1b7b53.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/aboutus/img/banner.png
// module id = 0ss5
// module chunks = 1